<template>
  <div
    class="modal fade"
    :ref="`modal-apartment-img-component`"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4
            v-if="
              apartmentImg.apartmentImgType ===
                ApartmentImgTypeEnum.APARTMENT_CONTRACT_IMG
            "
            class="modal-title"
          >
            {{ $t("apartment.apartmentContract.title") }}
          </h4>
          <h4 v-else class="modal-title">
            {{
              $t(
                apartmentImg.id === 0 ? "common.addNewImg" : "common.imgDetail"
              )
            }}
          </h4>
        </div>
        <div class="modal-body">
          <div
            v-if="
              apartmentImg.apartmentImgType ===
                ApartmentImgTypeEnum.APARTMENT_CONTRACT_IMG
            "
            class="row"
          >
            <div class="col-md-12">
              <div class="form-group required">
                <label class="control-label required" for="">{{
                  $t("apartment.apartmentContract.attachFile")
                }}</label>
                <div>
                  <div class="mt-3" style="position: relative;">
                    <label
                      :for="
                        `upload-apartment-img${apartmentImg.apartmentImgType}`
                      "
                      class="custom-file-upload"
                    >
                      <i
                        class="glyphicon glyphicon-cloud-upload"
                        style="position: absolute; left: 10px; top: 30%; color: #cccccc; font-size: small;"
                      ></i>
                      <span style="font-size: small; word-wrap: break-word;">{{
                        fileName
                          ? fileName
                          : $t("newsManagement.residentNews.fileUpload")
                      }}</span>
                    </label>
                    <input
                      :id="
                        `upload-apartment-img${apartmentImg.apartmentImgType}`
                      "
                      type="file"
                      accept="application/pdf"
                      @change="onSelectAssetImg"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="">{{
                  $t("apartment.apartmentContract.apartmentContractTitle")
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="apartmentImg.description"
                />
              </div>
            </div>
          </div>
          <div v-else class="row">
            <div class="col-md-12">
              <div class="form-group required">
                <label class="control-label required" for="">{{
                  $t("banner.image")
                }}</label>
                <div>
                  <img
                    id="apartment-img-id"
                    class="asset-img-class img-responsive"
                    :src="
                      apartmentImg.imgUrl !== null && apartmentImg.imgUrl !== ''
                        ? apartmentImg.imgUrl
                        : noImgDefault
                    "
                    alt="asset-img"
                    @click="onOpenInputSelectFile"
                  />
                  <div style="padding-top: 6px; text-align: center">
                    <input
                      :id="
                        `upload-apartment-img${apartmentImg.apartmentImgType}`
                      "
                      type="file"
                      accept="image/*"
                      @change="onSelectAssetImg"
                    />
                    <p>
                      <small>{{ $t("banner.clickImageToAddOrUpdate") }}</small>
                    </p>
                    <span
                      v-if="
                        apartmentImg.imgUrl !== null &&
                          apartmentImg.imgUrl !== ''
                      "
                      class="remove-asset-img"
                      @click="onClickRemoveApartmentImg"
                      >{{ $t("common.delete") }}</span
                    >
                  </div>
                </div>
                <!-- <input
                  type="text"
                  class="form-control"
                  v-model="apartmentImg.imgUrl"
                /> -->
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="">{{ $t("apartmentGroup.description") }}</label>
                <textarea
                  class="form-control"
                  name=""
                  id=""
                  cols="30"
                  rows="4"
                  v-model="apartmentImg.description"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            style="background-color: #f29911;border-color: #f29911;color:#fff"
            type="button"
            class="btn btn-default pull-left"
            data-dismiss="modal"
          >
            {{ $t("common.back") }}
          </button>
          <button type="button" class="btn btn-primary" @click="onSave">
            {{ $t("common.save") }}
          </button>
        </div>
      </div>
    </div>
    <lte-core-alert
      v-for="snackbar in GET_SNACK_BAR"
      :key="snackbar.id"
      :item="snackbar"
    ></lte-core-alert>
  </div>
</template>
<script>
import configuration from "@/lib/config";
import utils, { uploadFileToMediaAgent } from "@/lib/utils";
import Enum from "../../../enum/enum";
import { mapActions, mapGetters } from "vuex";
import LTECoreAlert from "@/components/LTESnackBar.vue";

export default {
  components: {
    "lte-core-alert": LTECoreAlert
  },
  props: {
    apartmentId: {
      type: Number,
      default: () => {
        return 0;
      }
    }
  },
  data: () => ({
    apartmentImg: {
      id: 0,
      imgUrl: null,
      description: null,
      apartmentImgType: null
    },
    assetImgFileSize: null,
    assetImgFile: null,
    fileName: null,
    noImgDefault: configuration.imgUrlConfig.img_other_no_picture_available,
    ApartmentImgTypeEnum: Enum.ApartmentImgType
  }),
  watch: {},
  computed: {
    ...mapGetters([
      "GET_SNACK_BAR"
    ])
  },
  methods: {
    onOpenInputSelectFile: function() {
      $(`#upload-apartment-img${this.apartmentImg.apartmentImgType}`).click();
    },
    onShowAddNew: function(apartmentImgType) {
      $(this.$refs[`modal-apartment-img-component`]).modal("show");
      this.apartmentImg = {
        id: 0,
        imgUrl: null,
        description: null,
        apartmentImgType: apartmentImgType
      };
      this.fileName = null;
    },
    onShowDetail: function(data) {
      $(this.$refs[`modal-apartment-img-component`]).modal("show");
      this.apartmentImg = {
        id: data.id,
        imgUrl: data.imgUrl,
        description: data.description,
        apartmentImgType: data.apartmentImgType
      };
      let fileName = !utils.isEmptyString(data.imgUrl) ? data.imgUrl.split("/") : null;
      this.fileName = fileName[fileName.length - 1];
    },
    onCloseModal: function() {
      $(this.$refs[`modal-apartment-img-component`]).modal("hide");
    },
    onSave: async function() {
      if (utils.isEmptyString(this.apartmentImg.imgUrl)) {
        this.ON_SHOW_TOAST({
          message: this.$t("banner.image"),
          styleType: "danger"
        });
      } else if (
        this.apartmentImg.apartmentImgType ===
          this.ApartmentImgTypeEnum.APARTMENT_CONTRACT_IMG && utils.isEmptyString(this.apartmentImg.description)
      ) {
        this.ON_SHOW_TOAST({
          message: this.$t(
            "apartment.apartmentContract.apartmentContractTitle"
          ),
          styleType: "danger"
        });
      } else {
        if (!utils.isEmptyString(this.assetImgFileSize)) {
          await this.uploadAssetImg();
        }
        let data = {
          id: this.apartmentImg.id,
          imgUrl: this.apartmentImg.imgUrl,
          description: this.apartmentImg.description,
          apartmentId: this.apartmentId,
          type: this.apartmentImg.apartmentImgType
        };
        if (this.apartmentImg.id === 0) {
          this.CREATE_APARTMENT_IMG(data)
            .then(
              function() {
                this.getApartmentImg();
                this.onCloseModal();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
              }.bind(this)
            );
        } else {
          this.UPDATE_APARTMENT_IMG(data)
            .then(
              function() {
                this.getApartmentImg();
                this.onCloseModal();
                this.SUCCESS_TOAST();
              }.bind(this)
            )
            .catch(
              function() {
                this.ERROR_TOAST();
              }.bind(this)
            );
        }
      }
    },
    // img function
    /**
     * Select issuance img
     */
    onSelectAssetImg: function(e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.getResultFile(files[0]);
      this.assetImgFileSize = files[0].size;
      this.fileName = files[0].name;
      this.apartmentImg.imgUrl = URL.createObjectURL(files[0]);
    },
    /**
     * Get result file
     */
    getResultFile: function(file) {
      let vm = this;
      vm.assetImgFile = file;
    },
    onClickRemoveApartmentImg: function() {
      let inputForm = $(
        `#upload-apartment-img${this.apartmentImg.apartmentImgType}`
      );
      inputForm.val("");
      this.assetImgFile = null;
      this.assetImgFileSize = null;
      this.apartmentImg.imgUrl = null;
    },
    uploadAssetImg: async function() {
      if (this.assetImgFileSize > 10000000) {
        this.ON_SHOW_TOAST({
          message: this.$t("common.cannotExceed10MB"),
          styleType: "danger"
        });
      } else {
        this.apartmentImg.imgUrl = await uploadFileToMediaAgent(this.assetImgFile, "apartmentImg")
      }
    },
    getApartmentImg: function() {
      let filter = {
        params: {
          apartmentId: this.apartmentId,
          type: this.apartmentImg.apartmentImgType
        }
      };
      this.GET_APARTMENT_IMG_LIST(filter);
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "ON_SHOW_TOAST",
      "GET_APARTMENT_IMG_LIST",
      "CREATE_APARTMENT_IMG",
      "UPDATE_APARTMENT_IMG"
    ])
  },
  mounted() {}
};
</script>
<style scoped>
label.required:not(:empty):after,
.field-header.required:after {
  content: " *";
  color: red;
  position: absolute;
  right: 5px;
  top: 0px;
}
input[type="file"] {
  display: none;
}
.asset-img-class {
  margin: auto;
  width: 100%;
  max-width: 200px;
  max-height: 250px;
  object-fit: contain;
}
.label-text-center {
  padding-bottom: 10px;
}
.remove-asset-img {
  color: #ef5350;
  cursor: pointer;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  padding: 6px 30px;
  width: 100%;
  border-radius: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Apartment/ApartmentImgComponent.vue